module.exports = __webpack_public_path__ + "img/39.7a55a549.jpg";